import gql from 'graphql-tag';

export const ValidateResetPasswordLink = gql`
  query isPasswordResetLinkValid($token: String!) {
    isPasswordResetLinkValid(token: $token)
  }
`;

export const ValidateSetPasswordLink = gql`
  query isPasswordSetLinkValid($token: String!) {
    isPasswordSetLinkValid(token: $token)
  }
`;
